import BreadCrumb from "../../../components/BreadCrumb";
import Layout from "../../../components/Layout";
import { toast } from "react-toastify";
import { httprequest } from "../../../data/api";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PageLoader from "../../../components/PageLoader";
import { Icon } from "@iconify/react";
import Button from "../../../components/Button";
import useStyles from "../styles";
import useWindowSize from "../../../hooks/useWindow";
import { TableSearch } from "../../../components/Table/TableActions";
import Table from "../../../components/Table/Table";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import Badge from "../../../components/Badge";
import CreateInventory from "../../hostel/component/CreateHostelInventory";
import ArchiveHostelInventory from "../../hostel/component/HostelArchiveInventory";
import HostelInventoryCategory from "../../hostel/component/HostelInventoryCategory";
import ViewHostelInventory from "../../hostel/component/ViewHostelInventory";
import EditHostelInventory from "../../hostel/component/EditHostelInventory";
import Modal from "../../../components/Modal";

const HOSTEL_EDIT_ENDPOINT = "/api/v1/hostel-management/hostel/";
const GET_HOSTEL_INVENTORY = "/api/v1/hostel-management/hostel-inventory/inventories";
const PATCH_HOSTEL_INVENTORY = "/api/v1/hostel-management/hostel-inventory/";

const HostelInventory = () => {
  const { id } = useParams();
  const classes = useStyles();
  const navigate = useNavigate();
  const width = useWindowSize();
  const mobile = width < 600;
  const [hostels, setHostels] = useState([]);
  const [pageLoading, setrPageLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inventoryData, setInventoryData] = useState([]);
  const [searchResult, setSearchResult] = useState([]);
  const [filterStatus, setFilterStatus] = useState("");
  const [currentRow, setCurrentRow] = useState({});
  const [archiveModal, setArchiveModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [archiving, setIsArchiving] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [viewMode, setViewMode] = useState("inventory");

  /**
     * Fetches Hostel by ID
     */
  const getAllHostelbyID = () => {
    setrPageLoading(true);
    httprequest.get(`${HOSTEL_EDIT_ENDPOINT}${id}`).then((res) => {
      setHostels(res?.data?.data);
      setrPageLoading(false);
    }).catch((err) => {
      setrPageLoading(false);
      toast.error(err?.response?.data);
    });
  };

  // --| Handle the archive modal
  // const handleArchive = (row) => {
  //   setCurrentRow(row);
  //   setArchiveModal(!archiveModal);
  // };

  // --| Handle the opening of the inventory modal
  const handleDeleteModal = (row) => {
    setCurrentRow(row);
    setDeleteModal(!deleteModal);
  };

  // --| Handle the close of the archive modal
  const handleCloseArchiveModal = () => {
    setArchiveModal(false);
    setCurrentRow({});
  };

  // --| Handle the close of the delete modal
  const handleCloseDeleteModal = () => {
    setDeleteModal(false);
    setCurrentRow({});
  };

  // --| Handle the filter based on selected status
  const handleFilterChange = (e) => {
    const { value } = e.target;
    setFilterStatus(value);

    // Filter assignments based on selected status
    const filteredByStatus = value === "used"
      ? inventoryData?.filter((data) => data?.condition === "used")
      : value === "new"
        ? inventoryData?.filter((data) => data?.condition === "new")
        : value === "broken"
          ? inventoryData?.filter((data) => data?.condition === "broken")
          : value === "good"
            ? inventoryData?.filter((data) => data?.condition === "good")
            : value === "poor"
              ? inventoryData?.filter((data) => data?.condition === "poor")
              : value === "damaged"
                ? inventoryData?.filter((data) => data?.condition === "damaged")
                : value === "others"
                  ? inventoryData?.filter((data) => data?.condition === "others")
                  : inventoryData;
    setSearchResult(filteredByStatus);
  };

  // --| Get all inventory data
  const getAllHostelInventory = () => {
    setIsLoading(true);
    httprequest.get(`${GET_HOSTEL_INVENTORY}?hostel_id=${id}`).then((res) => {
      setIsLoading(false);
      setInventoryData(res?.data?.data?.inventories);
      setSearchResult(res?.data?.data?.inventories);
    }).catch((err) => {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    });
  };

  // --| Handle the delete of inventory
  const handleDeleteInventory = () => {
    setIsDeleting(true);
    httprequest.delete(`${PATCH_HOSTEL_INVENTORY}${currentRow?.id}?hostel_id=${id}`).then(() => {
      setIsDeleting(false);
      handleCloseDeleteModal();
      getAllHostelInventory();
      toast.success("Inventory Deleted");
    }).catch((err) => {
      setIsDeleting(false);
      toast.error(err?.response?.data?.message);
    });
  };

  // --| Handle the archiving of inventory
  const handleArchiveInventory = () => {
    setIsArchiving(true);
    httprequest.patch(`${GET_HOSTEL_INVENTORY}?hostel=${id}/${currentRow?.id}`, { status: "archived" }).then(() => {
      setIsArchiving(false);
      handleCloseArchiveModal();
      getAllHostelInventory();
      toast.success("Inventory Archived Succesfully");
    }).catch((err) => {
      setIsArchiving(false);
      toast.error(err?.response?.data?.message);
    });
  };

  useEffect(() => {
    getAllHostelbyID();
    getAllHostelInventory();
  }, []);

  const columns = [
    {
      name: "Name",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Name</p>}
          {row?.name || "--/--"}
        </>
      )
    },
    {
      name: "Employee In-Charge",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Employee In-Charge</p>}
          {`${row?.employee_in_charge?.last_name} ${row?.employee_in_charge?.first_name}` || "--/--"}
        </>
      )
    },
    {
      name: "Category",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Category</p>}
          {row?.category?.category || "--/--"}
        </>
      )
    },
    {
      name: "Condition",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Condition</p>}
          <Badge status={row?.condition} />
        </>
      )
    },
    {
      name: "Created At",
      selector: (row) => (
        <>
          {mobile && <p className="mobile-styling">Created At</p>}
          {row?.created_at?.substring(0, 10) || "--/--"}
        </>
      )
    },
    {
      name: "Status",
      center: "true",
      cell: (row) => (<Badge status={row?.status} />)
    },
    {
      name: "",
      center: true,
      sortable: false,
      cell: (row) => (
        <div key={row?.id} className="table-action-container">
          <button
            onClick={() => {
              setSelectedItemId(row?.id);
              setViewMode("view");
            }}
            className="table-action-icon"
          >
            <Icon icon="fluent:eye-16-regular" />
          </button>
          <button onClick={() => {
            setSelectedItemId(row?.id);
            setViewMode("edit");
          }} className="table-action-icon"
          >
            <Icon icon="heroicons:pencil-square-solid" />
          </button>
          {/* <button
            onClick={() => handleArchive(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="material-symbols:archive-outline" />
          </button> */}
          <button
            onClick={() => handleDeleteModal(row)}
            className="table-action-icon delete-icon"
          >
            <Icon icon="mingcute:delete-2-line" />
          </button>
        </div>
      )
    }
  ];

  // --| Filter Inventory table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value?.split(" ");
    const filteredByStatus = filterStatus
      ? inventoryData?.filter((data) => data?.status?.toLowerCase() === filterStatus?.toLowerCase())
      : inventoryData;
    // --| Filter data by partial match onchange in the search input box
    const result = filteredByStatus?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                    data?.condition
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                    data?.category?.category
                      ?.toLowerCase()
                      .includes(word.toLowerCase()) ||
                      data?.status
                        ?.toLowerCase()
                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  return (
    <Layout children={
      <>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb
              link_one={`/hostel/${hostels?.hostel?.id}`}
              link_one_name="Hostel Management"
              active={`${hostels?.hostel?.name} inventory`}
              description="See details of inventory in a hostel"
            />
          </div>
          <div>
          </div>
        </div>
        <div className="page-content margin-top-16">
          {pageLoading ? (
            <PageLoader />
          ) : (
            <>
              <div className={classes.hosteldetail}>
                <h2>{hostels?.hostel?.name || "--/--"}</h2>
                <p>{hostels?.hostel?.gender || "--/--"} Hostel | {hostels?.hostel?.number_of_bedspace || "--/--"}-Man Room</p>
              </div>
              <div className={`${classes.overview} margin-top-16`}>
                <div className={classes.flexx}>
                  <div className={classes.invenhead}>
                    <div onClick={() => viewMode === "inventory"
                      ? navigate(`/hostel/${hostels?.hostel?.id}`)
                      : setViewMode("inventory")
                    } className="text-center cursor-pointer"
                    >
                      <Icon icon="eva:arrow-back-fill" />
                      <p>Back</p>
                    </div>
                    <h4>Hostel Inventory</h4>
                  </div>
                  <div className="flex gap-10">
                    {/* <Button onClick={() => setViewMode("archive")} variant="primaryoutline" buttonSize="small" color="btnfontprimary" buttonName="View Archive" /> */}
                    <Button onClick={() => setViewMode("create")} variant="primary" buttonSize="fluid" color="btndefault" buttonName="Create Inventory" />
                  </div>
                </div>
                <div
                  className={`${classes.fadeContainer} ${viewMode !== "inventory" ? classes.fadeHidden : ""}`}
                >
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      <div className="action_div">
                        <TableSearch
                          placeholder="Search here..."
                          searchTableFunc={handleSearchInventory}
                          isLoading={isLoading}
                        />
                        <div className="flex gap-10">
                          <div className={classes.actionitem} onClick={() => setViewMode("category")}>
                            <p>Manage Categories</p>
                          </div>
                          <div>
                            <SelectGroup
                              children={
                                <select name="type" onChange={handleFilterChange}>
                                  <option value="">-- Filter --</option>
                                  <option value="new">New</option>
                                  <option value="used">Used</option>
                                  <option value="broken">Broken</option>
                                  <option value="good">Good</option>
                                  <option value="poor">Poor</option>
                                  <option value="damaged">damaged</option>
                                  <option value="others">Others</option>
                                </select>
                              }
                            />
                          </div>
                        </div>
                      </div>
                    }
                  />
                </div>
                <div key={viewMode} className={classes.fadeContent}>
                  {viewMode === "archive" && <ArchiveHostelInventory />}
                  {viewMode === "create" && <CreateInventory />}
                  {viewMode === "category" && <HostelInventoryCategory />}
                  {viewMode === "view" && <ViewHostelInventory item_id={selectedItemId} />}
                  {viewMode === "edit" && <EditHostelInventory item_id={selectedItemId} />}
                </div>
              </div>
            </>
          )}

        </div>
        {/* Archive Modal */}
        <Modal
          title="Archive Inventory"
          subtitle={
            <div>Are you sure you want to archive <span className="modal-name-highlight">{currentRow?.name}</span>. If archived, employee will no longer have access to this Inventory.`
            </div>}
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" buttonName="Archive Inventory" buttonSize="full" color="btndefault" onClick={handleArchiveInventory} isLoading={archiving} />
            </>
          }
          isopen={archiveModal}
          closeModal={handleCloseArchiveModal}
        />
        {/* Delete Modal */}
        <Modal
          title="Delete Inventory"
          subtitle={
            <div>Are you sure you want to delete <span className="modal-name-highlight">{currentRow?.name}</span>. If deleted, employee will no longer have access to this Inventory.`
            </div>}
          modalContent={
            <>

            </>
          }
          modalFooter={
            <>
              <Button variant="danger" buttonName="Delete Inventory" buttonSize="full" color="btndefault" onClick={handleDeleteInventory} isLoading={isDeleting} />
            </>
          }
          isopen={deleteModal}
          closeModal={handleCloseDeleteModal}
        />
        {/* <ToastContainer /> */}
      </>
    }
    />
  );
};

export default HostelInventory;
